import React from 'react';
import PropTypes from 'prop-types';

const ReportIcon = ({ color = '#000000', width = 24, height = 24 }) => (
  <svg 
    width={width} 
    height={height} 
    viewBox="0 0 24 24" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
  >
    <path 
      d="M13,12a5,5,0,0,1-5,5v3a1,1,0,0,0,1,1H20a1,1,0,0,0,1-1V4a1,1,0,0,0-1-1H9A1,1,0,0,0,8,4V7A5,5,0,0,1,13,12Z" 
      fill={color}
      opacity="0.3"
    />
    <path 
      d="M8,17v3a1,1,0,0,0,1,1H20a1,1,0,0,0,1-1V4a1,1,0,0,0-1-1H9A1,1,0,0,0,8,4V7" 
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      fill="none"
    />
    <path 
      d="M8,7a5,5,0,1,1-5,5A5,5,0,0,1,8,7ZM3,12H8V7A5,5,0,0,0,3,12Z" 
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      fill="none"
    />
  </svg>
);

ReportIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};

export default ReportIcon;
